import script from "./supplement-facts-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./supplement-facts-panel.vue?vue&type=script&setup=true&lang=js"

import "./supplement-facts-panel.vue?vue&type=style&index=0&id=56085ece&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56085ece"]])

export default __exports__